/**
 * Cart classs
 */

export class ICategoryItem {
  id: number;
  parent_id: number;
  name: string;
  description: string;
  views: number;
  image_url: string;
  is_visible: boolean;
}

export class IProductOption {
  name: string;
  nameId: number;
  value: string;
  valueId: number;
}

// this is catalog product; which is different from cart or order line items
export class IProductItem {
  id: number;
  sku: string;
  name: string;
  product_id?: number;
  productId?: string;
  images?: string;
  url?: string;
  quantity: number;
  taxable?: boolean;
  image_url?: string;
  discounts?: any[];
  coupons?: any[];
  discount_amount?: number;
  coupon_amount?: number;
  list_price: number;
  sale_price: number;
  price?: number;
  calculated_price?: number;
  extended_list_price?: number;
  extended_sale_price?: number;
  is_require_shipping?: boolean;
  is_mutable?: boolean;
  variants?: IVariantItem[];
  options?: IProductOption[];
  custom_fields?: IProductItemCustomField;
  type?: string;
  optionType?: string;
  variantId?: number;
  variant_id?: number;
  totalInsuranceAmount?: number;
  subTotalAmount?: number;
  coupon?: string;
}

export class IProductItemCustomField {
  [key: string]: string;
}
// setting it as an interface because it's causing an error of circular dependency when set to class
export interface IVariantItem {
  id: number;
  product_id: number;
  sku: string;
  sku_id: number;
  price: number;
  calculated_price: number;
  // sale_price: null,
  // retail_price: null,
  // map_price: null,
  // weight: null,
  // calculated_weight: 0,
  // width: null,
  // height: null,
  // depth: null,
  // is_free_shipping: false,
  // fixed_cost_shipping_price: null,
  // purchasing_disabled: false,
  // purchasing_disabled_message: ,
  // image_url: ,
  // cost_price: 0,
  // upc: ,
  // mpn: ,
  // gtin: ,
  // inventory_level: 0,
  // inventory_warning_level: 0,
  // bin_picking_number: ,
  option_values: {
    id: number;
    label: 'One-Time' | 'Every 3 Months';
    option_id: number;
    option_display_name: 'subscription';
  }[];
}
export class ICart {
  _id?: string; // cart has no _id because it's from bigC
  id: string;
  customer: any;
  customer_id: number;
  channel_id: number;
  email: string;
  currency: {
    code: string;
  };
  tax_included: boolean;
  base_amount: number;
  discount_amount: number;
  cart_amount: number;
  coupons: any[];
  line_items: {
    physical_items: ICartLineItem[];
    digital_items: ICartLineItem[];
    gift_certificates: any[];
    custom_items: any[];
  };
  created_time: Date;
  updated_time: Date;
}

export class IUpdateOrderItemDTO {
  id?: number;
  name?: string;
  product_id?: number;
  variant_id?: number;
  quantity?: number;
  product_options?: [
    {
      id: number;
      value: number;
    }
  ];
  price_inc_tax?: number;
  price_ex_tax?: number;
  sku?: string;
}

export class ICreateInvoiceItemDTO {
  price: string; // Price plan object hash ID
  quantity?: number;
}

export class ICreateCustomInvoiceItemDTO {
  unit_amount?: number; // Amount in cents
  quantity?: number;
  description: string;
  currency: 'cad' | 'usd';
}

export class ICartLineItem {
  id?: string; // id of the item within the cart
  sku?: string;
  quantity: number;
  product_id?: number;
  list_price?: number; // Optional price override
  variant_id?: number; // Exists only in Catalog V3
  name?: string;
  description?: string;
}

export class ICustomCartLineItem {
  sku: string;
  name: string;
  quantity: number;
  list_price: number;
  discount_amount?: number;
  sale_price?: number;
  extended_list_price?: number;
  extended_sale_price?: number;
  type: string;
}
